<div class="h-100 d-flex flex-column">
  <div class="d-flex justify-content-between  user-b mb-1 flex-wrap">
    <div class="search-cont mt-3 mt-sm-4">
      <div class="s-in form-input" style="position:relative">
        <mat-icon class="input-icon">search</mat-icon>
        <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput" (input)="onSearch($event)" />
      </div>
    </div>
    <button mat-raised-button color="primary" class="primary-btn mt-2 mt-md-4 mb-sm-2 mb-md-0" type="submit"
      (click)="onAddEdit('add')"><i class="fas fa-plus"></i> Add New </button>
  </div>
  <div class="d-flex flex-grow-1 mt-4 flex-wrap flex-md-nowrap" *ngIf="selectedNote">
    <div class="note-left flex-shrink-0">
      <div *ngFor="let item of notesArr">
        <div class="note-details cursor-pointer d-flex" [ngClass]="{'sel-notes':selectedNote.id==item.id}" (click)="onSelectNotes(item)">
          <div class="not-tit" >{{item.tit}}</div>
          <div class="flex-grow-1 d-flex d-md-none align-items-end flex-column" style="text-align:end">
            <mat-icon *ngIf="item.selected">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!item.selected">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div *ngIf="item.selected==true" class="mt-3 d-md-none">
          <div [ngTemplateOutlet]="notesData"></div>
        </div>
      </div>
    </div>
    <div class="note-right flex-grow-1 d-none d-md-flex flex-column">
      <div [ngTemplateOutlet]="notesData"></div>
    </div>
  </div>
  <div *ngIf="!selectedNote">
    <div class="mat-table__message">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
    </div>
  </div>
</div>
<ng-template #notesData>
  <div class="d-flex note-box flex-wrap">
    <div class="flex-grow-1">
      <div class="note-tit ">{{selectedNote?.tit}}</div>
      <div class=" attach-b" *ngIf="selectedNote?.file">
        <div class="flex-grow-1 d-flex align-items-center" (click)="onAttachment()">
          <i class="text-danger material-icons me-1">picture_as_pdf</i>
          Attachment
        </div>
        <div style="width: 18px;">
          <img src="assets/images/icons/download_ic .svg" class="img-fluid" alt="">
        </div>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-end r-b">
      <div class="d-flex align-items-center justify-content-end">
        <div class="action-btn" (click)="onAddEdit('edit')" matTooltip="Edit">
          <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
        </div>
        <div class="action-btn" matTooltip="Delete" (click)="onDeleteItem()">
          <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
        </div>
      </div>
      <div>
        <span class="text-semibold grey1">Last Edited On: </span>
        <span class="grey2">{{selectedNote?.c_at! | dates }}</span>
      </div>
    </div>
  </div>
  <div class="note-desc mt-3 mt-md-0 flex-grow-1">
    <textarea name="" id="" [value]="selectedNote?.notes" rows="" disabled></textarea>
  </div>
</ng-template>